import {apiCall} from './index.ts';

export type Sender =
{
    firstName: string;
    lastName: string;
    email: string;
    schedulingUrl: string;
    businessInfo1: string;
    businessInfo2: string;
    businessInfo3: string;
}

export type Viewer = {
    name: string;
    email: string;
    phone: string;
}

export type Presentation = {
    name: string;
    blockActions?: string;
    musicId?: string;
    musicUrl?: string;
    musicLabel?: string;
    musicThumbUrl?: string;
}

export type Geolocation = {
    accuracyRadius:number;
    city:string;
    continentCode:string;
    continentName:string;
    countryCode:string;
    countryFlagEmojiUnicode:string;
    countryName:string;
    currencyCode:string;
    currencyName:string;
    currencySymbol:string;
    languageCode:string;
    languageName:string;
    languageNameNative:string;
    latitude:number;
    longitude:number;
    regionCode:string;
    regionName:string;
    timeZoneCode:string;
    timeZoneId:string;
    zip:string;
}

export type InvitationResponse = {
    sender: Sender;
    viewer: Viewer;
    presentation: Presentation;
    postALink: boolean;
    viewUuid?: string;
    geolocation: Geolocation | null;
}

export type PostALinkResponse = {
    viewUuid: string;
    geolocation: Geolocation;
}

export type SessionVariable = {
    name: string;
    value: string;
    localizedText: Map<string, string> | null;
}

export async function createSession(urlCode?: string, previewToken?: string): Promise<InvitationResponse> {
    return apiCall<InvitationResponse>(`/sessions/`,
        {
            method: 'POST',
            data: {
                urlCode: urlCode,
                previewToken: previewToken,
            }
        });
}

export async function startPostALinkSession(urlCode: string, viewerName: string, viewerEmail: string, viewerPhone: string): Promise<PostALinkResponse> {
    return apiCall<PostALinkResponse>(`/sessions/postALink/`,
        {
            method: 'POST',
            data: {
                urlCode: urlCode,
                viewerName: viewerName,
                viewerEmail: viewerEmail,
                viewerPhone: viewerPhone,
            }
        });
}

export async function markStarted(viewUuid:string): Promise<boolean> {
    return apiCall<boolean>(`/sessions/${viewUuid}/start`,
        {
            method: 'PUT',
            data: { }
        });
}

export async function markFinished(viewUuid:string, actionResponse?: string, actionResponseStatus?: string): Promise<boolean> {
    return apiCall<boolean>(`/sessions/${viewUuid}/finish`,
        {
            method: 'PUT',
            data: {
                actionResponse: actionResponse,
                actionResponseStatus: actionResponseStatus,
            }
        });
}

export async function keepAlive(viewUuid:string): Promise<void> {
    return apiCall<void>(`/sessions/${viewUuid}/keepAlive`,
        {
            method: 'PUT',
            data: { }
        });
}

export async function slideStarted(viewUuid:string, slideIndex: number): Promise<void> {
    return apiCall<void>(`/sessions/${viewUuid}/slides/start`,
        {
            method: 'POST',
            data: {
                slideIndex: slideIndex
            }
        });
}

export async function storeSessionVariables(viewUuid:string, variables: SessionVariable[]): Promise<boolean> {
    return apiCall<boolean>(`/sessions/${viewUuid}/variables`,
        {
            method: 'POST',
            data: variables
        });
}

export async function updateGeolocation(viewUuid:string): Promise<Geolocation | null> {
    return apiCall<Geolocation | null>(`/sessions/${viewUuid}/geolocation/update`,
        {
            method: 'PUT',
            data: {}
        });
}

